import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  inject,
  OnDestroy,
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { TimeInputComponent } from '../time-input/time-input.component';

@Component({
  selector: 'et-atoms-time-field',
  standalone: true,
  imports: [],
  templateUrl: './time-field.component.html',
  styleUrl: './time-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeFieldComponent implements OnDestroy, AfterContentInit {
  private elementRef = inject(ElementRef);

  labelClickSub!: Subscription;

  @ContentChild(TimeInputComponent, { read: ElementRef })
  timeInputComponent!: ElementRef;

  ngAfterContentInit(): void {
    const label = this.elementRef.nativeElement.querySelector('label');

    if (!label) {
      console.error(
        '<label></label> is required inside <et-atoms-time-field></et-atoms-time-field> component',
      );
      return;
    }

    const label$ = fromEvent(label, 'click');
    this.labelClickSub = label$.subscribe(() => {
      const inputElement =
        this.timeInputComponent?.nativeElement.querySelector('input');
      inputElement?.focus();
    });
  }

  ngOnDestroy(): void {
    this.labelClickSub?.unsubscribe();
  }
}
